import React, { useState, useEffect } from "react"
import Button from '@mui/material/Button'
import BotaoVoltar from "./common/botaoVoltar";
import DistVafCircularProgress from "./common/distVafCircularProgress";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import IconButton from '@mui/material/IconButton';
import { useNavigate } from "react-router-dom";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Collapse from '@mui/material/Collapse';
import Alert from '@mui/material/Alert';
import CloseIcon from '@mui/icons-material/Close';
import Tooltip from '@mui/material/Tooltip';
import $ from 'jquery'
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import { URL_API } from '../config/urls'
import fetchWithToken from 'config/UseFetchWithToken';

export default function Srf() {

	const [dados, setDados] = useState([]);
	const [mostrarModal, setMostrarModal] = useState(false);
	const [srfAtual, setSrfAtual] = useState(false);
	const [srfAtualId, setSrfAtualId] = useState(false);
	const [mostraMensagem, setMostrarMensagem] = useState(false)
	const [mensagem, setMensagem] = useState("")
	const [loader, setLoader]  = useState(true);
	let nav = useNavigate();

	useEffect(() => {
		setLoader(true)

		let token_keycloack = sessionStorage.getItem('token_keycloack');
		const requestAuthorization = {
			headers: { "Authorization": `Bearer ${token_keycloack}` }
		}

		fetchWithToken(`${URL_API}/api/v1/srf/obterSrf`, requestAuthorization)
			.then(res => res.json())
			.then(res => {
				setLoader(false)
				if (res === "") {
					this.resultado = "Não foi possível carregar os dados de SRF!"
				}
				else {
					setDados(res)
					$(document).ready(function () {
						setTimeout(function () {
							$('#tblDados').DataTable({
								columnDefs: [
									{ orderable: false, targets: 2 },
									{ orderable: false, targets: 3 },
									{ orderable: false, targets: 4 }
								],
								lengthMenu: [[10, 50, 100, -1], [10, 50, 100, "Todos"]],
								pageLength: 1000,
								order: [[1, 'asc']],
								language: {
									url: '/pt-BR.json'
								}
							});
						}, 100);
					});
				}
			})
			.catch(_err => {
				console.error("Ocorreu um erro - " + _err)
			});
	}, [])

	function alterarSrf(e) {
		nav("/distvaf/editarSrf/" + e);
		return null
	}

	function confirmarExclusao() {

		let token_keycloack = sessionStorage.getItem('token_keycloack');
		const opcoes = {
			method: 'DELETE',
			headers: { 'Content-Type': 'application/json' , "Authorization": `Bearer ${token_keycloack}`}
		};
		fetchWithToken(`${URL_API}/api/v1/srf/${srfAtualId}`, opcoes)
			.then(res => res.text())
			.then(_res => {
				const newState = dados.filter(item => item.codigo !== srfAtualId)
				setDados(newState)
				setMensagem("O registro foi excluído!")
				setMostrarMensagem(true)
			})
			.catch(_err => {
				setMensagem("Ocorreu um erro!")
				console.error("Ocorreu um erro:"+_err)
			});
		setMostrarModal(false)
		return null
	}

	function excluirSrf(id, nome) {
		setSrfAtualId(id)
		setSrfAtual(nome)
		setMostrarModal(true)
		return null
	}

	function exibirHistorico(id) {
		nav("/distvaf/historicoSrf/" + id);
		return null
	}

	function fecharMensagem() {
		setMostrarMensagem(false)
		return null
	}

	function fecharModal() {
		setMostrarModal(false)
		return null
	}

	return (
		<div className="container-fluid">
			<div className="row">
				<div className="col-12">
					<Collapse in={mostraMensagem}>
						<Alert action={<IconButton aria-label="close" color="inherit" size="small" onClick={ () => fecharMensagem()} focusRipple={mostraMensagem}><CloseIcon fontSize="inherit" /></IconButton>} sx={{ mb: 2 }}>{mensagem}</Alert>
					</Collapse>
					<header className="main">
						<h2>DISTVAF - Cadastro de SRF</h2>
					</header>
				</div>
			</div>
			<div className="row">
				<div className="col-6">
					<Button variant="contained" color="primary" onClick={ () => nav("/distvaf/editarSrf/0")}>Inserir nova SRF</Button>
				</div>
				<div className="col-6">
					<BotaoVoltar />
				</div>
			</div>
			<div className="row">
				<div className="col-12">
				{(loader && <DistVafCircularProgress />)}
					<form method='post' action='#'>
						<div className="margem-antes">
							<table id="tblDados" className="stripe row-border">
								<thead>
									<tr>
										<th>SRF</th>
										<th>Email</th>
										<th className="botao"></th>
										<th className="botao"></th>
										<th className="botao"></th>
									</tr>
								</thead>
								<tbody>
									{dados.sort(function (a, b) {
										if (a.nome > b.nome) { return 1; }
										if (a.nome < b.nome) { return -1; }
										return 0;
									}).map(result => {
										return (
											<tr className="center" key={result.codigo}>
												<td>{result.nome}</td>
												<td>{result.email}</td>
												<td className="align-center">
													<Tooltip title="Histórico">
														<IconButton className="pad0" color="primary" onClick={ () => exibirHistorico(result.codigo)}>
															<AccessTimeFilledIcon />
														</IconButton>
													</Tooltip>
												</td>
												<td className="align-center">
													<IconButton className="pad0" color="primary" onClick={ () => alterarSrf(result.codigo) }><EditIcon /></IconButton>
												</td>
												<td className="align-center">
													<IconButton className="pad0" color="error" onClick={ () => excluirSrf(result.codigo, result.nome) }><DeleteIcon /></IconButton>
												</td>
											</tr>
										);
									})
									}
								</tbody>
							</table>
						</div>
					</form>
				</div>
				<Dialog open={mostrarModal} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
					<DialogTitle id="alert-dialog-title">Atenção</DialogTitle>
					<DialogContent>
						<DialogContentText id="alert-dialog-description">
							Confirma a exclusão da SRF {srfAtual}?
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button variant="contained" color="error" onClick={ () => confirmarExclusao()}>Confirmar</Button>
						<Button variant="contained" color="primary" onClick={ () => fecharModal()}>Cancelar</Button>
					</DialogActions>
				</Dialog>
			</div>
		</div>
	)
}
